module.exports = __webpack_public_path__ + "fonts/vivo-fonts.2b24b30b.eot";